<template>
    <div>  
      <Churchportal v-if="$store.state.auth.user_status_id==2"></Churchportal>    
      <Adminportal v-if="$store.state.auth.user_status_id==1"></Adminportal>
    </div>
</template>
<script>
  import Churchportal from './Dashboardcomponent/Churchportal'; 
  import Adminportal from './Dashboardcomponent/Adminportal';
  export default {
    components: {
     Churchportal,     
     Adminportal
    },  
    data() {
      return {       
       
      };
    }, 
    mounted(){
       if (!this.$store.getters.isLoggedIn) {
          this.$store.dispatch('logout')
          this.$router.push('/login')
      }
    }  
       
  };
</script>
<style></style>
